export default __webpack_public_path__ + "static/media/IRQ.11ed4950.svg";